module.exports = __webpack_public_path__ + "img/artmuseo_bandlogo_reg.90bbd80c.svg";